import React, { useEffect, useRef, useState } from "react";
import { Menu, Tabs, Drawer, theme, Input, Grid, Select } from "antd";
import TradeTable from "./TradeTable";
import {
  SearchOutlined,
  RightCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Divider, Space, Tour } from "antd";
import { useLayout } from "../Context/LayoutContext";
import $ from "jquery";
/*tab asset image */
import t1 from "../Assets/t1.png";
import t5 from "../Assets/t5.png";
import t6 from "../Assets/t6.png";
import t3 from "../Assets/t3.png";
import Axios from "../Axios";
import { Loader } from "../Loader/Loader";
import { AnimatePresence, motion } from "framer-motion";
import { icons } from "antd/es/image/PreviewGroup";
const { useBreakpoint } = Grid;
const DropTesting = ({ children }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const screens = useBreakpoint();
  const { onClose, addAsset, openDrawer, tabs, percent } = useLayout();
  const [pairs, setPairs] = useState([]);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const isSmall = window.innerWidth <= 1600;
  const istab = window.innerWidth <= 991;
  const isMedium = window.innerWidth <= 767;
  const [currentPage, setCurrentPage] = useState(1); // ✅ pagination page
  const [pageSize, setPageSize] = useState(10);
  const [type, setType] = useState("crypto");
  const [isMobile, setIsMobile] = useState(false);
  const [chartType, setChartType] = useState("binary");
  const [activeKey, setActiveKey] = useState("1");
  const items2 = [
    {
      key: "sub2",
      label: "Binary Options",
      icon: <img src={t5} />,
      children: [
        { key: "1", label: "Crypto" },
        // { key: '6', label: 'Futures' },
        { key: "7", label: "Forex" },
      ],
    },

    { key: "2", label: "Future Crypto", icon: <img src={t1} /> },
    { key: "3", label: "Forex", icon: <img src={t3} /> },
    { key: "4", label: "Commodities", icon: <img src={t6} /> },
  ];

  const commonColumns = [
    { title: "Sort by Popularity", dataIndex: "name" },
    // {
    //   title: "Price",
    //   dataIndex: "price",
    //   align: "right",
    //   render: (value) => <span className="quantity-cell">{value}</span>,
    // },
    { title: "Payout", dataIndex: "profit", align: "center" },
  ];

  const futureColumns = [
    { title: "Sort by Popularity", dataIndex: "name" },
    { title: "Sell", dataIndex: "sell" },
    { title: "Buy", dataIndex: "buy" },
    { title: "Spread", dataIndex: "spread" },
    // { title: "Change", dataIndex: "change" },
  ];

  const forexColumns = [
    { title: "Sort by Popularity", dataIndex: "name" },
    { title: "Sell", dataIndex: "sell" },
    { title: "Buy", dataIndex: "buy" },
    { title: "Spread", dataIndex: "spread" },
    // { title: "Change", dataIndex: "change" },
  ];

  // 🔹 Build columns based on tab and screen size
  const baseColumns =
    activeTab === "3" // Forex tab
      ? forexColumns
      : activeTab === "2" // Futures tab
        ? futureColumns
        : commonColumns;

  // 🔹 Modify columns for mobile
  const columns =
    isMobile && activeTab === "1"
      ? [
        { title: "Asset", dataIndex: "name" },
        { title: "Payout", dataIndex: "profit" },
      ]
      : isMobile
        ? [
          { title: "Asset", dataIndex: "name" },
          { title: "Spread", dataIndex: "spread" },
        ]
        : baseColumns;

  const [tableColumns, setTableColumns] = useState(columns);

  const wsRef = useRef(null);
  const handleTabChange = (key) => {
    setSearch("");
    if (key === "1") {
      setType("crypto");
      setChartType("binary");
      setTableColumns(columns);
    } else if (key === "2") {
      setType("future");
      setChartType("trade");
      setTableColumns(futureColumns);
    } else if (key === "3") {
      setType("forex");
      setChartType("trade");
      setTableColumns(forexColumns);
    } else if (key === "4") {
      setType("commodities");
      setChartType("trade");
      setTableColumns(futureColumns);
    } else if (key === "7") {
      setChartType("binary");
      setType("forex");
      setTableColumns(columns);
    }
    setCurrentPage(1);
  };

  const onClick = (e) => {
    handleTabChange(e.key);
    setActiveKey(e.key);
    console.log("click ", e.key);
  };

  const handleBinaryMobiile = (value) => {
    console.log(value, "key");
    handleTabChange(value);
  };

  // const connectCryptoWebSocket = () => {
  //   try {
  //     let pingInterval;

  //     const url =
  //       type === "crypto"
  //         ? "wss://stream.binance.com:9443/ws"
  //         : "wss://fstream.binance.com/ws";

  //     console.log("Connecting to:", url);
  //     const ws = new WebSocket(url);
  //     wsRef.current = ws;

  //     ws.onopen = () => {
  //       const streamType = type === "crypto" ? "@ticker" : "@bookTicker";

  //       const symbols = pairs?.map(
  //         (data) =>
  //           data.pair_symbol.toLowerCase().replace("_", "") + streamType,
  //       );

  //       // Subscribe
  //       ws.send(
  //         JSON.stringify({
  //           method: "SUBSCRIBE",
  //           params: symbols,
  //           id: 1,
  //         }),
  //       );
  //       // console.log("Subscribed to:", symbols);

  //       pingInterval = setInterval(() => {
  //         if (ws.readyState !== WebSocket.OPEN) {
  //           clearInterval(pingInterval);
  //           console.warn("WebSocket closed, clearing interval");
  //         }
  //       }, 30000);
  //     };

  //     ws.onmessage = (event) => {
  //       try {
  //         const parsedData = JSON.parse(event.data);
  //         const symbol = parsedData?.s;
  //         if (!symbol) return;

  //         let bid, ask;

  //         // SPOT: @ticker
  //         if (type === "crypto" && parsedData.e === "24hrTicker") {
  //           bid = parseFloat(parsedData.b);
  //           ask = parseFloat(parsedData.a);
  //         }

  //         // FUTURES: @bookTicker
  //         if (type !== "crypto" && parsedData.e === "bookTicker") {
  //           bid = parseFloat(parsedData.b);
  //           ask = parseFloat(parsedData.a);
  //         }

  //         if (!bid || !ask) return;

  //         const spread = parseFloat((ask - bid).toFixed(6));

  //         // Update UI
  //         $(`.buy-${symbol}`).html(`<span style="color:#009A2C">${ask}</span>`); // buy (ask)
  //         $(`.sell-${symbol}`).html(`<span style="color:red">${bid}</span>`); // sell (bid)
  //         $(`.spread-${symbol}`).html(`<span>${spread}</span>`);
  //         $(`.price-${symbol}`).html(
  //           `<span>${parseFloat(parsedData.c)?.toFixed(5)}</span>`,
  //         );
  //       } catch (err) {
  //         console.error("Error parsing WS message:", err);
  //       }
  //     };

  //     ws.onerror = (error) => {
  //       console.error("WebSocket Error:", error);
  //     };

  //     ws.onclose = () => {
  //       console.log("WebSocket Connection Closed");
  //       clearInterval(pingInterval);
  //     };
  //   } catch (err) {
  //     console.log("WebSocket connection error:", err);
  //   }
  // };
  const connectCryptoWebSocket = () => {
    try {
      let pingInterval;

      const url =
        type === "crypto"
          ? "wss://stream.binance.com:9443/ws"
          : "wss://fstream.binance.com/ws";

      console.log("Connecting to:", url);
      const ws = new WebSocket(url);
      wsRef.current = ws;

      ws.onopen = () => {
        const streamType = type === "crypto" ? "@ticker" : "@bookTicker";

        const symbols = pairs?.map(
          (data) => data.pair_symbol.toLowerCase().replace("_", "") + streamType
        );

        // Subscribe
        ws.send(
          JSON.stringify({
            method: "SUBSCRIBE",
            params: symbols,
            id: 1,
          })
        );
        // console.log("Subscribed to:", symbols);

        pingInterval = setInterval(() => {
          if (ws.readyState !== WebSocket.OPEN) {
            clearInterval(pingInterval);
            console.warn("WebSocket closed, clearing interval");
          }
        }, 30000);
      };

      ws.onmessage = (event) => {
        try {
          const parsedData = JSON.parse(event.data);
          const symbol = parsedData?.s;
          if (!symbol) return;

          let bid, ask;

          // SPOT: @ticker
          if (type === "crypto" && parsedData.e === "24hrTicker") {
            bid = parseFloat(parsedData.b);
            ask = parseFloat(parsedData.a);
          }

          // FUTURES: @bookTicker
          if (type !== "crypto" && parsedData.e === "bookTicker") {
            bid = parseFloat(parsedData.b);
            ask = parseFloat(parsedData.a);
          }

          if (!bid || !ask) return;

          const spread = parseFloat((ask - bid).toFixed(6));

          // Update UI
          $(`.buy-${symbol}`).text(ask.toFixed(6)); // buy (ask)
          $(`.sell-${symbol}`).text(bid.toFixed(6)); // sell (bid)
          $(`.spread-${symbol}`).text(spread.toFixed(6));
          $(`.price-${symbol}`).text(parseFloat(parsedData.c)?.toFixed(6));
        } catch (err) {
          console.error("Error parsing WS message:", err);
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket Error:", error);
      };

      ws.onclose = () => {
        console.log("WebSocket Connection Closed");
        clearInterval(pingInterval);
      };
    } catch (err) {
      console.log("WebSocket connection error:", err);
    }
  };


  useEffect(() => {
    if (!openDrawer) {
      // 🧹 Drawer closed → cleanup visuals only (optional)
      setLoading(false);
    } else {
      // ✅ Drawer opened
      setLoading(true); // show loader every time you open drawer

      // 🚫 Don't refetch if we already have data
      if (pairs.length === 0) {
        getTradingPairs();
      } else {
        // just delay hiding the loader for better feel
        setTimeout(() => setLoading(false), 1500);
      }
    }
  }, [openDrawer]);

  useEffect(() => {
    if (type === "crypto" || type === "future") {
      connectCryptoWebSocket();
    } else if (type === "forex") {
      // forexWebSocket();
    } else {
    }
    return () => {
      if (wsRef.current) {
        try {
          const pair = pairs.map((d) => {
            const symbol = d.pair_symbol;
            if (symbol.length === 6) {
              const base = symbol.slice(0, 3);
              const quote = symbol.slice(3);
              return `${base}/${quote}`;
            }
            return symbol;
          });
          const symbolsString = pair.join(",");
          wsRef.current.send(
            JSON.stringify({
              action: "unsubscribe",
              params: {
                symbols: symbolsString,
              },
            }),
          );
          console.log("Unsubscribed from Forex WS in DropDown");
        } catch (e) {
          console.log(e);
        }
        wsRef.current.close();
      }
    };
  }, [data, type]);
  const [total, setTotal] = useState(0);

  const getTradingPairs = async () => {
    try {
      console.log("Fetching trading pairs...", type);
      const { data: resp } = await Axios.post(
        `/getPairsByAdmin?page=${currentPage}&limit=${13}`,
        {
          type: type,
        },
        {},
      );
      if (resp?.success) {
        setPairs(resp?.result);
        setTotal(resp?.total);
      } else {
        setPairs([]);
      }
    } catch (error) {
      setPairs([]);
    } finally {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1500);

      return () => clearTimeout(timer);
    }
  };

  // Maps any DB pair_symbol variant → AllTick DOM class key used by commodityContext
  const COMMODITY_DOM_MAP = {
    GOLD: "GOLD", XAUUSD: "GOLD", XAU: "GOLD", XAUUSDT: "GOLD",
    SILVER: "Silver", XAGUSD: "Silver", XAG: "Silver", XAGUSDT: "Silver",
    PLATINUM: "Platinum", XPTUSD: "Platinum", XPT: "Platinum", XPTUSDT: "Platinum",
  };

  useEffect(() => {
    const formatedRow = [];
    for (let i = 0; i < pairs.length; i++) {
      const rawPair = pairs[i]?.pair_symbol.split("_").join("");
      const socketPairs =
        type === "commodities"
          ? COMMODITY_DOM_MAP[rawPair.toUpperCase()] ?? rawPair
          : rawPair;
      const symbol = pairs[i]?.pair_symbol.split("_").join("/");
      const displayName =
        type === "commodities" ? pairs[i]?.base_asset_name || symbol : symbol;
      const obj = {};
      obj.key = i + 1;
      obj.name = (
        <div className="display-1 asset-table">
          {type === "forex" ? (
            <img width="25" height="25" src={pairs[i]?.icon} alt="tether--v1" />
          ) : (
            <img width="25" height="25" src={pairs[i]?.icon} alt="tether--v1" />
          )}

          {displayName}
        </div>
      );
      obj.assetName = symbol;

      obj.icon =
        type === "forex" ? (
          <img width="25" height="25" src={pairs[i]?.icon} alt="tether--v1" />
        ) : (
          <img width="25" height="25" src={pairs[i]?.icon} alt="tether--v1" />
        );

      obj.sell = (
        <div className="display-1 font-15 asset-table" style={{ color: "red" }}>
          <span className={`sell-${socketPairs}`}></span>
        </div>
      );
      obj.buy = (
        <div
          className="display-1 font-15 asset-table"
          style={{ color: "green" }}
        >
          <span className={`buy-${socketPairs}`}></span>
        </div>
      );
      obj.spread = (
        <div className="display-1 font-15 asset-table">
          <span className={`spread-${socketPairs}`}></span>
        </div>
      );

      obj.profit = (
        <div
          className="display-1 font-15 asset-table"
          style={{ color: "#1E7237" }}
        >
          {percent}%
        </div>
      );

      // obj.price = (
      //   <div className="display-1 font-15 asset-table">
      //     <span className={`price-${socketPairs}`}></span>
      //   </div>
      // );
      // obj.quantity = 4.831385
      // obj.margin = <div className="prof">88%</div>
      if (
        displayName?.toLowerCase()?.includes(search?.toLowerCase()) ||
        symbol?.toLowerCase()?.includes(search?.toLowerCase())
      ) {
        formatedRow.push(obj);
      }
    }
    setData(formatedRow);
  }, [pairs, type, search]);

  useEffect(() => {
    setLoading(true);
    getTradingPairs();
  }, [type, activeTab, chartType, currentPage]);

  const option = (
    <>
      <div className="display-1">
        {/* <Input
          placeholder="Search by name"
          style={{ width: "100%" }}
          prefix={<SearchOutlined />}
          className="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        /> */}
        {chartType === "binary" && !screens.lg && (
          <Select
            defaultValue={"1"}
            // defaultValue="All Positions"
            style={{ width: "150px", marginTop: "15px" }}
            onChange={(value) => handleBinaryMobiile(value)}
            suffixIcon={
              <svg
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M6.66667 10L0 0H14L6.66667 10Z" fill="var(--fnt)" />
              </svg>
            }
            className="history-select"
            options={[
              // { value: "AllPositions", label: "All Positions" },
              { value: "1", key: "1", label: "Crypto" },
              { value: "7", key: "2", label: "Forex" },
              // { value: "disabled", label: "Disabled", disabled: true },
            ]}
            id="cs"
          />
        )}
      </div>

      {loading ? (
        <Loader />
      ) : (
        <AnimatePresence mode="wait">
          {openDrawer && (
            <TradeTable
              scroll={{ x: "max-content", y: "100%" }}
              pagination={{
                current: currentPage,
                pageSize: 13,
                total: total, // or real total if server paginated
              }}
              onPaginationChange={(page) => {
                setLoading(true); // ✅ Show loader
                setCurrentPage(page);

                // simulate server pagination or re-fetch
                getTradingPairs(); // your API call already toggles loading
              }}
              columns={tableColumns}
              data={data}
              className={"ast-table"}
              onRow={(record) => ({
                onClick: () => {
                  if (tabs.length >= 6) return;
                  addAsset(
                    record.assetName,
                    type,
                    chartType,
                    record?.icon?.props?.src,
                    istab,
                    isMedium,
                  );

                  console.log(
                    record.assetName,
                    type,
                    chartType,
                    record?.icon?.props?.src,
                    istab,
                    isMedium,
                    "pairs",
                  );

                  onClose();
                  onClose();
                },
              })}
            />
          )}
        </AnimatePresence>
      )}
    </>
  );

  const [openTrigger, setOpenTrigger] = useState(0);

  useEffect(() => {
    if (openDrawer) setOpenTrigger((v) => v + 1); // retrigger animation on open
  }, [openDrawer]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const tabData = [
    { key: "1", img: t5, text: "Binary Options", count: 109 },
    { key: "2", img: t1, text: "Future Crypto", count: 40 },
    // { key: "3", img: t3, text: "Forex", count: 23 },
  ];

  // const filteredTabs = isMobile
  //   ? tabData.filter((tab) => tab.text !== "Forex")
  //   : tabData;

  const items = tabData.map((tab, index) => ({
    key: tab.key,
    label: (
      <AnimatePresence mode="wait">
        <motion.div
          key={`label-${tab.key}-${openTrigger}`}
          initial={{
            opacity: 0,
            rotateX: -75,
            scale: 0.95,
            y: 20,
            transformOrigin: "top center",
          }}
          animate={{
            opacity: 1,
            rotateX: 0,
            scale: 1,
            y: 0,
          }}
          transition={{
            duration: 1.5, // fixed 1 second
            delay: index * 0.08, // smooth stagger
            ease: [0.22, 1, 0.36, 1], // smooth cubic easing
            scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 },
          }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.97 }}
          className="display-1 asset-tab-custom"
          style={{
            transformStyle: "preserve-3d",
            backfaceVisibility: "hidden",
            perspective: 100,
          }}
        >
          {" "}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              delay: index * 0.15, // slight natural delay
              duration: 0.4,
              ease: "easeOut",
            }}
            className="display-1"
          >
            <img src={tab.img} alt={tab.text} className="tab-img" />
            {tab.text}

            {/* <Badge
              className="site-badge"
              count={tab.count}
              style={{ backgroundColor: "#7C808A" }}
            /> */}
          </motion.div>
        </motion.div>
      </AnimatePresence>
    ),
    children: option,
  }));

  return (
    <div className="topd-raw">
      <Drawer
        // title="Payment method"
        placement="right"
        closable={true}
        onClose={onClose}
        open={openDrawer}
        getContainer={false}
        closeIcon={
          <RightCircleOutlined
            className="close-drawer-icon"
            style={{
              color: "#ffffff",
              fontSize: "25px",
            }}
          />
        }
        // style={{
        //   position: "absolute", // not fixed
        //   height: "100%",
        // }}
        width={isMedium ? "100%" : isSmall ? "70%" : "51%"}
        className="dynamic-draw"
      >
        <h6 className="back-btn">
          <ArrowLeftOutlined
            onClick={onClose}
            style={{
              color: "currentColor",
              fontSize: "18px",
              cursor: "pointer",
            }}
          />{" "}
          Choose an asset
        </h6>
        {screens.lg ? (
          <div
            className="display-1"
            style={{ alignItems: "flex-start", height: "100%" }}
          >
            <Menu
              onClick={onClick}
              style={{
                width: 256,
                background: "var(--bg-mn)",
                color: "var(--fnt)",
              }}
              selectedKeys={activeKey}
              defaultSelectedKeys={["1"]}
              defaultOpenKeys={["sub1"]}
              mode="inline"
              className="asste-menu"
              items={items2}
            />
            <div style={{ width: "100%", height: "100%" }}>{option}</div>
          </div>
        ) : (
          <Tabs
            defaultActiveKey="1"
            activeKey={activeTab}
            onChange={(key) => {
              setActiveTab(key);
              setLoading(true);
              handleTabChange(key);
            }}
            items={items}
            tabPosition="left"
            style={{ height: "100%" }}
            className="asset-tab"
          />
        )}
      </Drawer>
    </div>
  );
};

export default DropTesting;
